
import axiosInstance from "../../../../api/AxiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { customerRestaurantDetailRequest, customerRestaurantDetailRequestError, customerRestaurantDetailRequestSuccess } from "../../../slices/User/Detail/CustomerRestaurantDetailSlice";
import { getCustomerRestaurantCompletedOrdersRequest, getCustomerRestaurantCompletedOrdersRequestError, getCustomerRestaurantCompletedOrdersRequestSuccess } from "../../../slices/User/Detail/GetCustomerRestaurantCompletedOrdersSlice";
export const CustomerRestaurantCompletedOrdersApi = ({ userId, page, limit, type }) => async (dispatch) => {

    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        userId: userId,
        type: type
    }).toString();

    const urlWithParams = `${endpoints.customerRestaurantDetail}?${queryParams}`;
    try {
        dispatch(getCustomerRestaurantCompletedOrdersRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCustomerRestaurantCompletedOrdersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCustomerRestaurantCompletedOrdersRequestError(_error));
            });
    } catch (error) {
    }
};
